import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import _ from 'lodash';
import translatedRoutes from '../config/translatedRoutes';

const mapStateToProps = state => ({
  country: state.country,
});

@connect(mapStateToProps)
export default class TranslatedLink extends React.PureComponent {
  render() {
    const { country, name, routeParams, children, className, onClick } = this.props;
    const route = translatedRoutes[country][name];

    if (!route) {
      throw new Error(`Translated route "${name}" not found`);
    }

    let href = route.url;
//console.log(`routeParams route.url: ` + JSON.stringify(href));
    if (routeParams) {
     //console.log(`routeParams translatelink: ` + JSON.stringify(routeParams));
      href = _.reduce(routeParams, (path, param) => path.replace(/:\w+/, param), href);
    }
href = href.replace('dakar-rally', 'formula-2').replace('moto-3', 'formula-3').replace('british-superbike', 'imsa').replace('rio-2016', 'tokyo-2021');
    //return <Link to={{pathname: href}} className={className} onClick={onClick}>{children}</Link>;
    return <a href={href} className={className}>{children}</a>;
  }
}

TranslatedLink.propTypes = {
  name: React.PropTypes.string.isRequired,
  routeParams: React.PropTypes.array,
  children: React.PropTypes.any.isRequired,
  country: React.PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/component/TranslatedLink.jsx